module.exports = __webpack_public_path__ + "img/sigin.63a54382.svg";